import _ from 'lodash';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap, map, catchError } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';

import * as SummaryActions from './summary.actions';
import { VirtualEventService } from 'app/virtual-event/services/virtual-event.service';
import { updateCampaignList } from 'app/campaign/features/campaign.actions';
import { Store } from '@ngrx/store';


@Injectable()
export class SummaryEffects {

  loadVirtualEventSummary$ = createEffect(() => {
    return this.actions$.pipe( 
      ofType(SummaryActions.loadVirtualEventSummary),
      concatMap((action: any) => {
        const { payload } = action;
        return this.virtualEventService.getVirtualEventSummary(payload).pipe(
          map(data => SummaryActions.loadVirtualEventSummarySuccess({ data })),
          catchError(error => of(SummaryActions.loadVirtualEventSummaryFailure({ error }))))
      })
    );
  });


  constructor(
    private actions$: Actions,
    private virtualEventService: VirtualEventService,
  ) {}

}
